import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { usePermissions } from 'hooks/usePermissions/usePermissions';
import { AppRoute } from 'routing/AppRoute.enum';
import { LicenseModalContext } from '../licenseModalContext/LicenseModalContext';
import { LicenseModalStatus } from '../licenseModalContext/LicenseModalContext.types';

import { LicenseModalContextControllerProps } from './LicenseModalContextController.types';
import { LicenseModal } from './LicenseModal';

export const LicenseModalContextController = ({ children }: LicenseModalContextControllerProps) => {
  const [isLicenseModalOpen, setIsLicenseModalOpen] = useState(false);
  const [licenseStatus, setLicenseStatus] = useState<LicenseModalStatus | null>(null);
  const { perms } = usePermissions();
  const navigate = useNavigate();

  const canManageLicense = !!perms?.LICENCJA?.view;
  const isLicenseInvalid = licenseStatus === 'EXPIRED' || licenseStatus === 'NOT_FOUND';

  const handleLicenseModalOpen = (isModalOpen: boolean, status?: LicenseModalStatus) => {
    setIsLicenseModalOpen(isModalOpen);
    if (status) {
      setLicenseStatus(status);
    }
    if (isModalOpen) {
      navigate(AppRoute.profile);
    }
  };

  return (
    <LicenseModalContext.Provider
      value={{ isLicenseModalOpen, licenseStatus, isLicenseInvalid, handleLicenseModalOpen }}
    >
      {children}
      <LicenseModal
        isModalOpen={isLicenseModalOpen}
        onClose={() => setIsLicenseModalOpen(false)}
        canManageLicense={canManageLicense}
        licenseStatus={licenseStatus}
      />
    </LicenseModalContext.Provider>
  );
};
